/** Import modules */

import { useTranslation }   from "react-i18next";

import { useQuery }         from "@apollo/client";

import { Helmet }           from "react-helmet-async";

import {
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedValue,
    normalizeLanguage
}                           from "../../Components/SEO/localizedMeta";

import { FrontEndPages }    from "../../Queries/Policies";

import ComponentLoader from "../../Components/Layout/Loaders/Loader";

import cookies              from "js-cookie";

import parse               from "html-react-parser";

/** Import components */

import Breadcrumbs          from "../../Components/Layout/Header/Breadcrumbs";

import ContentsLayout       from "../../Components/Contents/Layout";

/**
 * 
 * @returns Payments page
 * 
 */

const Payments = () => { const { t, i18n } = useTranslation (),

    currentLanguage = normalizeLanguage(i18n?.resolvedLanguage || i18n?.language),

    canonicalHref = localizedAbsoluteUrl("/content/payments", currentLanguage),

    alternateLinks = hreflangLinks("/content/payments"),

    pageDescription = localizedValue({
        lv: "Norēķinu informācija Tireshop.lv: pieejamas apmaksas metodes, pirkuma noformēšana un droši maksājumi par riepām, diskiem, akumulatoriem un pakalpojumiem.",
        en: "Payment information at Tireshop.lv: available payment methods, checkout flow, and secure payments for tires, rims, batteries, and services.",
        ru: "Информация об оплате в Tireshop.lv: доступные способы оплаты, оформление заказа и безопасные платежи за шины, диски, аккумуляторы и услуги."
    }, currentLanguage),

    { data, loading } = useQuery ( FrontEndPages, { variables: { pageType: "payments", language: cookies.get ( 'i18next' ) } } );

    /** Render component */

    return ( <div className="container max-content-width">

        <Helmet>

            <title>{ `Tireshop.lv | ${ t ( "payments" ) }` }</title>

            <meta
                name="description"
                content={ pageDescription }
            />

            <link rel="canonical" href={ canonicalHref } />

            { alternateLinks.map((item) => (
                <link
                    key={ item.hreflang }
                    rel="alternate"
                    hrefLang={ item.hreflang }
                    href={ item.href }
                />
            )) }

        </Helmet>

        <Breadcrumbs collection={ [

            { name: t ( "payments" ), URI: "/content/payments" }

        ] } />

        <ContentsLayout title={ t ( "payments" ) }>

            { 

                loading ? <ComponentLoader /> :

                    data?.frontendPages?.edges[0]?.node?.content ?
            
                        parse ( data.frontendPages.edges[0].node.content ) :

                        <p>Unable to retrive data.</p>
                
            }

        </ContentsLayout>
        
    </div> );

}

/** Export component */
 
export default Payments;
